<div class="mat-typography">
  <main-navigation [navigationEntries]="navEntries"> </main-navigation>
</div>
